import { SidebarEvents } from '@core/modules/event-bus/events/sidebar/sidebar-events';
import { ThemeEvents } from '@core/modules/event-bus/events/theme/theme-events';

/**
 * Grouped exports for convenience
 */
export const AppEvents = {
  Sidebar: SidebarEvents,
  Theme: ThemeEvents,
} as const;
